import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import type { AttemptsMode } from "@/lib/analytics/types";

interface AttemptsModeToggleProps {
  value: AttemptsMode;
  onChange: (mode: AttemptsMode) => void;
}

export function AttemptsModeToggle({ value, onChange }: AttemptsModeToggleProps) {
  const checked = value === "all";

  function handleCheckedChange(next: boolean) {
    onChange(next ? "all" : "first-pass");
  }

  return (
    <div className="flex items-center gap-2">
      <Switch
        id="include-reruns"
        checked={checked}
        onCheckedChange={handleCheckedChange}
      />
      <Label htmlFor="include-reruns" className="text-sm cursor-pointer select-none">
        Include re-runs
      </Label>
    </div>
  );
}
